<template>
  <div class="container">
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        id="solutionname"
        :to="{ path: '/private-cloud-hosted-esign-system' }"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
      >
        <v-row justify="center" class="">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/EsignSystem.webp')"
                  class="white--text"
                  width="700"
                  height="200"
                ></v-img>
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong> <h2>Private Cloud Hosted eSign System</h2> </strong>
              <br />
              Introducing Our Next-Gen eSign Solution: Redefining Digital
              Signatures with Custom Workflow and Private Deployment
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        id="solutionname"
        :to="{ path: '/employment-agency-contract-generation-system' }"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
      >
        <v-row justify="center" class="">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/Employment.webp')"
                  class="white--text"
                  width="700"
                  height="200"
                ></v-img>
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  Employment Agency Contract Generation and eSign Solution
                </h2>
              </strong>
              <br />
              Our innovative product leverages AI-Based Analytics and NLP
              Capabilities and offers a private cloud deployment option,
              allowing you to have full control over your data while ensuring
              compliance with regulatory requirements.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <a href="https://glam-connect.com/" target="_blank">
        <v-card
          height="100%"
          id="solutionname"
          :elevation="hover ? 16 : 2"
          :class="{ 'on-hover': hover }"
        >
          <v-row justify="center" class="">
            <v-col sm="12" md="4" lg="4">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-img
                    :src="require('@/assets/salon.webp')"
                    class="white--text"
                    width="700"
                    height="200"
                  ></v-img>
                  <v-list-item-subtitle /> <br />
                  <v-list-item-subtitle> </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col sm="12" md="8" lg="8">
              <p style="padding: 20px; text-align: justify">
                <strong> <h2>Salon Management System</h2> </strong>
                <br />
                A pioneer Salon Management Software, helps Salon owners to
                maintain relation with clients using its features : POS ,
                Inventory, Appointment
              </p>

              <div class="my-2 pl-3">
                <v-btn color="white black--text" dark>
                  visit product onfo page
                  <v-icon color="black" class="px-2" size="20" right>
                    mdi-open-in-new</v-icon
                  >
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </a>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <a href="https://maidagencysoftware.com/" target="_blank">
        <v-card
          height="100%"
          :elevation="hover ? 16 : 2"
          :class="{ 'on-hover': hover }"
        >
          <v-row justify="center" class="">
            <v-col sm="12" md="4" lg="4">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-img
                    :src="require('@/assets/ma.webp')"
                    class="white--text"
                    width="700"
                    height="200"
                  ></v-img>
                  <v-list-item-subtitle /> <br />
                  <v-list-item-subtitle> </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col sm="12" md="8" lg="8">
              <p style="padding: 20px; text-align: justify">
                <strong> <h2>Maid Agency System</h2> </strong>
                <br />
                We know that you are facing these following issues:
              </p>

              <div style="padding-left: 20px">
                <b>Our AI based software supports:</b>
                <ul>
                  <li>
                    Difficulty in managing your employers and domestic workers
                    data
                  </li>
                  <li>
                    Not able to capture leads / enquiries from your website or
                    calls
                  </li>
                  <li>Having to toil with physical copies of agreements</li>
                  <li>
                    Potential clients have to be present in your office to look
                    through many of your domestic workers’ biodatas; etc.
                  </li>
                  <li>Maid Biodata Entry Module</li>
                </ul>
              </div>
              <div class="my-2 pl-3 pt-2">
                <v-btn color="white black--text" dark>
                  visit product onfo page
                  <v-icon color="black" class="px-2" size="20" right>
                    mdi-open-in-new</v-icon
                  >
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </a>
    </v-hover>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
}
</style>
